import axiosInstance from '../axiosInterceptor/axiosInstance'

const invitationReject = async (data) => {
  const { orgId, invitationId } = data
  const url = `v1/orgs/${orgId}/invitations/${invitationId}/reject`
  return axiosInstance.post(url)
}

export default invitationReject
